/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createEmailTemplateDataSchema = z.object({
	organisationId: z.string().uuid(),
	name: z.string(),
	subject: z.string().nullable().optional(),
	body: z.string().nullable().optional(),
})

export type CreateEmailTemplateDataSchema = z.infer<typeof createEmailTemplateDataSchema>
